import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { LuNavigation as GpsFixedIcon, LuNavigationOff as GpsNotFixedIcon } from 'react-icons/lu';
import { useDispatch, useSelector } from 'react-redux';

import { clientConfig } from '../../../config/client-config';
import { environment } from '../../../infra/environment/environment';
import { AppState } from '../../../infra/store';
import { WebsocketService } from '../../../infra/websocket/service';
import Show from '../show';

const Websocket = () => {
  // eslint-disable-next-line
  const [websocketService, setWebsocketService] = useState<WebsocketService>(undefined);
  const dispatch = useDispatch();
  const isOnline = useSelector((state: AppState) => state.websocketReducer.isConnected);

  useEffect(() => {
    if (dispatch === undefined) return;

    const service = WebsocketService.getInstance(environment.recordWebsocketEndpoint, dispatch);

    setWebsocketService(service);
  }, [dispatch]);

  return (
    <Tooltip title="Indica si el sistema esta conectado">
      <Box sx={{ display: 'flex', alignItems: 'center', alignContent: 'center' }}>
        <IconButton>
          <Show when={isOnline}>
            <GpsFixedIcon style={{ color: clientConfig.themes.light.colors.primary.main }} />
          </Show>
          <Show when={!isOnline}>
            <GpsNotFixedIcon style={{ color: '#9e9e9e' }} />
          </Show>
        </IconButton>
        <Typography color={isOnline ? 'primary' : 'text'}>
          <strong>{isOnline ? 'Conectado' : 'Desconectado'}</strong>
        </Typography>
      </Box>
    </Tooltip>
  );
};

export default Websocket;
